<div
  class="no-sum text-center mb-4">
  @if (result === null) {
    <div
      class="mb-3 error-text pt-4 pb-4">
      <strong> {{ 'bvs.valuesMissing' | transloco }}</strong>
    </div>
  } @else {
    @if (result.publicCalculationResultStatus === CalculationResultStatus.Error) {
      <div
        class="error-text pt-4 pb-4">
        <strong>{{ 'bvs.requestOffer' | transloco }}</strong>
      </div>
    }
    @if (result.publicCalculationResultStatus === CalculationResultStatus.Error) {
      <div class="mb-1">{{ 'bvs.bvsCalculationAngebotAufAnforderung' | transloco }}:</div>
    }
    @if (result.publicCalculationResultStatus === CalculationResultStatus.OkWithWarning) {
      <div class="mb-1">{{ 'bvs.bvsCalculationOkMitHinweisen' | transloco }}:</div>
    }
    @if (result.publicCalculationResultStatusDetails?.length) {
      <ul class="list-unstyled pb-4">
        @for (statusDetails of result.publicCalculationResultStatusDetails; track $index) {
          <li>
            {{ $index + 1 }}. {{ statusDetails.translationKey | transloco }}
          </li>
        }
      </ul>
    }
  }
</div>
